import { ModalActionTypes } from '@acorns/web-components'

import platform from 'components/Trackers/platform'
import trackEvent from 'utils/analytics/trackEvent'

const eventDetails = {
  event_description: 'Button Tapped',
  platform,
  object: 'Button',
  action: 'Tapped',
  screen: 'registrationInformationSSN',
  screen_name: 'errorAlert',
}

export const generateErrorCodeMap = ({ env, getString, ...props }) => {
  const primaryActionText = getString({
    key: 'registration.personal_information.error.modal.ssn_invalid.contact_customer_support.cta',
  })
  const secondPrimaryActionText = getString({
    key: 'registration.personal_information.error.modal.ssn_invalid.had_an_account_before.cta',
  })
  const secondaryActionText = getString({
    key: 'registration.personal_information.error.modal.ssn_invalid.go_back.cta',
  })
  const ssnIssueValue = {
    title: getString({ key: 'registration.personal_information.error.modal.ssn_invalid.title' }),
    message: getString({ key: 'registration.personal_information.error.modal.ssn_invalid.body' }),
    actions: [
      {
        handler: () => {
          trackEvent('Button Tapped', {
            eventData: {
              ...eventDetails,
              feature: 'Registration Information: SSN Error Modal Support',
              object_name: 'registrationInformationSSNErrorAlertSupport',
              cta_title: primaryActionText,
            },
          })
          window.open(env.get('helpAppUrl'), '_blank')
        },
        label: primaryActionText,
        type: ModalActionTypes.primary,
      },
      {
        handler: () => {
          trackEvent('Button Tapped', {
            eventData: {
              ...eventDetails,
              feature: 'Registration Information: SSN Error Modal Existing Account',
              object_name: 'registrationInformationSSNErrorAlertExistingAccount',
              cta_title: secondPrimaryActionText,
            },
          })
          window.open(env.get('loginUrl'), '_blank')
        },
        label: secondPrimaryActionText,
        type: ModalActionTypes.primary,
      },
      {
        handler: () => {
          trackEvent('Button Tapped', {
            eventData: {
              ...eventDetails,
              feature: 'Registration Information: SSN Error Modal Cancel',
              object_name: 'registrationInformationSSNErrorAlertCancel',
              cta_title: secondaryActionText,
            },
          })
          props.closeErrorModal()
        },
        label: secondaryActionText,
        type: ModalActionTypes.secondary,
      },
    ],
  }
  return {
    'user_profile.ssn_used': ssnIssueValue,
    'user_profile.exists': ssnIssueValue,
    'user_profile.ssn_invalid': ssnIssueValue,
  }
}
